import type { Logger } from "@expert/logging";

import type { ChallengeDetails } from "../../../../api/getChallengesForEmployee";

export const findMyTeam = (logger: Logger, teams: ChallengeDetails[], employeeId: string) => {
    const childLogger = logger.child({ module: "findMyTeam", supportTeam: "sales" });
    const myTeam = teams.find((team) => team.empIds.includes(employeeId));
    if (!myTeam) {
        childLogger.warn({ teams }, "challenge found for which current expert is not a participant");
        return teams[0];
    }
    return myTeam;
};

export const sortTeams = (logger: Logger, teams: ChallengeDetails[], employeeId: string) => {
    teams.sort((a, _b) => (findMyTeam(logger, teams, employeeId) === a ? -1 : 0));
};
